import {SuccessfulApiResponse} from "@eryxcoop/appyx-comm";

export default class MarketplaceSearchResponse extends SuccessfulApiResponse {
    static defaultResponse() {
        return {
            object:
                {'articles':{
                    'article': {
                        'code': '4233',
                        'name': 'Baguette',
                        'fantasy_name': 'Baguette',
                        'items_amount': 20,
                        'category': 'Panadería Francesa',
                        'description': 'Descripción',
                        'weight': '20kg',
                        'measures': '20cm',
                        'cooking_time': '45 minutos',
                        'cooking_temperature': '200',
                        'ingredients': 'Harina',
                        'file': 'url/img.jpg',
                        'specification_sheet': 'url/specification_sheet.pdf'
                    }
                }
                },
            errors: []
        }
    }

    articles() {
        return this.content()
    }
}